import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { extractUrlFromText } from "@/lib/web-tools";
import { sharedData } from "@/features/shared-data-manager";

function SharePage() {
  const navigate = useNavigate();

  useEffect(() => {
    handleSharedData();
  }, []);

  async function handleSharedData() {
    if (window.location.pathname === "/share") {
      const urlParams = new URLSearchParams(window.location.search);
      const title = urlParams.get("title");
      const text = urlParams.get("text");
      const url = urlParams.get("url") || (text && extractUrlFromText(text));
      const data = {
        title,
        text,
        url,
      };
      console.log("Get Shared Data:", data);

      if (data) {
        sharedData.value = data;
        navigate("/main");
      }
    } else {
      console.error("Path is invalid: ", window.location.pathname);
    }
  }

  return (
    <div className="app">
      <div className="w-full h-full flex flex-col">
        <div className="mx-auto my-auto"></div>
      </div>
    </div>
  );
}

export default SharePage;
